import React from "react";

import { TabType, DESKTOP } from "@constants";

import { FiltersProps, IconsListProps } from "../../../types";

import FiltersDesktopFormBranches from "./FiltersDesktopFormBranches";
import FiltersDesktopFormAtms from "./FiltersDesktopFormAtms";

type FiltersDesktopProps = {
  type: TabType;
  handleOnChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
} & FiltersProps &
  IconsListProps;

const FiltersDesktop: React.FC<FiltersDesktopProps> = ({
  filters,
  iconsList,
  type,
  handleOnChange,
}) => {
  return (
    <div id={`filters-${DESKTOP}-${type}`} className="hidden sm:block">
      {type === TabType.Branches ? (
        <FiltersDesktopFormBranches
          filters={filters}
          iconsList={iconsList}
          type={type}
          handleOnChange={handleOnChange}
        />
      ) : (
        <FiltersDesktopFormAtms
          filters={filters}
          iconsList={iconsList}
          type={type}
          handleOnChange={handleOnChange}
        />
      )}
    </div>
  );
};

export default FiltersDesktop;
